import { useEffect, useState } from "react";
import SegmentsApiService from "app/services/segments/segmentsWizardService";
import type { IDomainsValidForSegments } from "app/pages/segments/wizard/SegmentFirstStep/SegmentCreationFirstStep";

interface EnrichedDomainData {
    isLoading: boolean;
    domainsValidForSegments?: IDomainsValidForSegments;
}
type Keys = Array<string>;

export const useEnrichedDomainData = (keys: Keys) => {
    const [enrichedDomainsData, setEnrichedDomainsData] = useState<EnrichedDomainData>({
        isLoading: true,
    });
    useEffect(() => {
        setEnrichedDomainsData({ isLoading: true });
        const segmentsApiService = new SegmentsApiService();
        segmentsApiService
            .isDomainValidForSegments({
                keys,
            })
            .then((domainsValidForSegments) => {
                const enrichedDomainData = { isLoading: false, domainsValidForSegments };
                setEnrichedDomainsData(enrichedDomainData);
            });
    }, [keys.join()]);
    return enrichedDomainsData;
};
